<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_7"></a>Contents</h2>
<p class="imagec"><img alt="Illustration" src="images/common.jpg"/></p>
<p class="toc"><a href="#/xhtml/fm01">Introduction</a></p>
<p class="toc"><a href="#/xhtml/fm02">Useful ingredients</a></p>
<p class="toc1"><span href="#/xhtml/chapter01" title="Link target outside of Sample">Bread, muffins and pastries</span></p>
<p class="toc"><span href="#/xhtml/chapter02" title="Link target outside of Sample">Cereals</span></p>
<p class="toc"><span href="#/xhtml/chapter03" title="Link target outside of Sample">Eggs</span></p>
<p class="toc"><span href="#/xhtml/chapter04" title="Link target outside of Sample">Pancakes and waffles</span></p>
<p class="toc"><span href="#/xhtml/chapter05" title="Link target outside of Sample">Fruit</span></p>
<p class="toc"><span href="#/xhtml/chapter06" title="Link target outside of Sample">Meat and fish</span></p>
<p class="toc"><span href="#/xhtml/chapter07" title="Link target outside of Sample">Vegetarian</span></p>
<p class="toc"><span href="#/xhtml/chapter08" title="Link target outside of Sample">Drinks</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2fdcc2ee